/**
 * Converts the input value to an array if it's an empty string.
 * @param {Object} input
 */
export const reduxFormArrayValueAdapter = (input) => {
    const {value} = input;
    return {...input, value: value === '' ? [] : value};
};
